import { useSelector } from 'react-redux';
import { EStatus } from 'shared/repositories/valuation-offer-history/entities/offer_from_history/OfferFromHistoryResponseV2Schema';
import { EDealType } from 'shared/repositories/valuation-offer-history/entities/offer_history/HouseOfferHistoryRequestV4Schema';
import { selectDealType } from 'shared/selectors';
import { selectOfferFromHistory } from 'shared/selectors/offersHistory';

export const useDeactivatedLabelTitle = (): string | null => {
  const offerFromHistory = useSelector(selectOfferFromHistory);
  const dealType = useSelector(selectDealType);

  if (offerFromHistory?.status === EStatus.Deactivated) {
    return dealType === EDealType.Sale ? 'Снято с продажи' : 'Снято с публикации';
  }

  return null;
};
